import React, { useRef, useState, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { language } from "../../stores/slices/languageSlice";
// import { UserContext } from '../../stores/Context/Context'
import { Download, Trash2, Upload, UploadCloud } from "react-feather";
import Dropzone from "react-dropzone";
import style from "../../../components/claimintake/uploadDocuments.module.css"
import { toast } from "react-toastify";
import { resetIsUploaded, resetUploadSuccess, uploadDocument } from "../../../stores/slices/document/uploadDocumentSlice";
import { Modal } from "antd";
import { Tooltip } from "antd";
import moment from "moment";
import { fetchAppDocList } from "../../../stores/slices/document/documentListSlice";
import { fetchAppFileDoc } from "../../../stores/slices/document/documentDownloadSlice";
import Loader from "../../../components/menu/Loader";
import Table from "../../../components/reactTable/Table";
import { getAllSessions } from "../../../utilities/API/supertokenServices";
import { documentValidation, areNamesUnique, fileSizeValidation} from "../../../utilities/validations/documentValidation";


function UploadDocuments() {

    const dispatch = useDispatch();

    const [files, setFiles] = useState([]);

    const applicationData = useSelector((state)=> state.appViewDetailsSlice);
    const loginData = useSelector((state)=> state.loginSlice);
    const sessionData = useSelector((state) => state.sessionSlice)
    const uploadDocData =  useSelector((state)=> state.uploadDocumentSlice)
    const DocumentList = useSelector((state) => state.documentListSlice);
    const [loader, setLoader] = useState(false)

    const docList =()=>{
      let data = {
        portalUserID:loginData.value.PortalUserID,
        applicationID:applicationData.viewAppInfo.applicationId,
        EmailAddress:loginData.value.EmailAddress,
        ReferenceID:loginData.value.EIN
      }
      dispatch(fetchAppDocList({appData: data, prgData: applicationData.program}))  
    }

  
    const onDrop = (acceptedFiles, rejectedFiles) => {
      let isProtected = [];
      const validFileExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".heif"];
      if (rejectedFiles.length > 0) {
        toast.error("Document file size exceeds 10MB limit");
      }
  
      let isValidFile = false;
      let valid = [];
      acceptedFiles.forEach((file,i) => {
        if (file?.name != "") {
           validFileExtensions.find((validFileExtension) => { 
            if(file.name.includes(validFileExtension)){
              isValidFile = true
              return true
            }else{
              isValidFile = false
            }})
          
          if (isValidFile) {
            const reader = new FileReader()
            reader.onload = (e) => {
              const int32View = new Uint8Array(e.target.result);
              isProtected.push(`${documentValidation(int32View)}`);
              if (
                (int32View.length > 4 && int32View[0] == 0xFF && int32View[1] == 0xD8 && int32View[2] == 0xFF && int32View[3] == 0xE0) || //jpg/jpeg
                (int32View.length > 4 && int32View[0] == 0x89 && int32View[1] == 0x50 && int32View[2] == 0x4E && int32View[3] == 0x47) || //png
                (int32View.length > 4 && int32View[0] == 0x25 && int32View[1] == 0x50 && int32View[2] == 0x44 && int32View[3] == 0x46) || //pdf 
                (int32View.length > 4 && int32View[0] == 0x0 && int32View[1] == 0x0 && int32View[2] == 0x0 && int32View[3] == 0x18) //heif
              ) {
                isValidFile = true;
                valid.push('true')
                // setFiles([...files, ...acceptedFiles])
              } else {
                isValidFile = false;
              }
            }
            reader.readAsArrayBuffer(file)
          } else {
            // toast.error("File type invalid, unable to upload");
            return false;
          }
        }
      })
      setTimeout(() => {
        let resultDoc = isProtected.every(value => value === 'true');
          let isNameValidations =  areNamesUnique(files,acceptedFiles);
          let fileSizeValid=fileSizeValidation(files,acceptedFiles)
        if (valid.length == acceptedFiles.length && resultDoc && fileSizeValid && isNameValidations) {
          
            setFiles([...files, ...acceptedFiles])
       
            // data(acceptedFiles)
           
         } else {
            if(!fileSizeValid){
              toast.error("Upload exceeds 15MB limit");
              return false  
            }else{
            if(!isNameValidations){
              toast.error("The document was not uploaded successfully. Please check the name of your file and try again.");
              return false
            }else{
              if(!resultDoc){
                toast.error("Error: Invalid file. Please remove password-protection and reupload the document.");
                return false;
              }else{
                toast.error("File type invalid, unable to upload");
                return false;
              }
            }
       }}}, 500 );
    }
  
    const removeImage = (e, i,file) => {
      e.preventDefault()
      let UploadDocuments_copy = [...files]
      UploadDocuments_copy.splice(i, 1);
      // UploadDocumentsClaims.splice(i, 1);
      setFiles(UploadDocuments_copy)
  
    }

   const uploadDoc = () =>{
    if(files.length > 0 ){
    let docARR = []
    files.map(uploadfile=>{
      var reader = new FileReader();
     reader.readAsDataURL(uploadfile);
      reader.onload = function () {
      let base64 = reader.result.split(",");
      var ext = /(?:\.([^.]+))?$/;
      let fileExt = ext.exec(uploadfile.name)[1];
      let fileName = uploadfile.name.split('.').slice(0, -1).join('.');
      let cleanName = fileName.replace(/["*:\|/?<>]/g,'');
      cleanName =cleanName.trim().split(" ").join("").substring(0, 41)
      cleanName=cleanName+new Date().toISOString().split("T")[0]+Math.floor(Math.random() * 100 + 1);
      var today = new Date();
  
          var dd = today.getDate();
          var mm = today.getMonth() + 1;
          var yyyy = today.getFullYear();
          if(dd<10) {
              dd='0'+dd;
          }
          if(mm<10) {
              mm='0'+mm;
          }
      today = yyyy.toString() + mm.toString() + dd.toString();
       let data =  {
       File_Type: "Application",
       FileTypeCode: "781",
       pxObjClass: "Embed-DragDropFile",
       pyCategory: "File",
       pyFileName:cleanName.trim().split(" ").join("").substring(0, 54)+'.'+fileExt,
       pyFileSource:base64[1],
         pyFileType: fileExt,
        pyNote:cleanName.trim().split(" ").join("").substring(0, 54),
        ReceptionDate: today,
        AssociatedApplications: [
          {
            ApplicationID: applicationData.viewAppInfo.applicationId
          }
        ],
        "Categories": [
  
          {
  
            "FileCategory": "",
  
            "FileCategoryCode": "",
  
            "FileCategoryID": "",
  
            "pxObjClass": ""
  
          }
  
        ],
       }
       docARR.push(data)
      };
    })
    
    let data ={
    PatientID: applicationData.patientInfo.patientId,
    PortalUserID : loginData.value.PortalUserID,
    EIN:loginData.value.EIN,
    EmailAddress:loginData.value.EmailAddress,
    Application_Id : applicationData.viewAppInfo.applicationId,
    Documents: docARR
    }

    setLoader(true);
    setTimeout(()=>{
      dispatch(uploadDocument({doc: data, prgData: applicationData.program}))
    },1000)
  }else{
      toast.warn('Please attach File')
  }
   }
   const afterDownload =  () => {
    setFiles([]);
    dispatch(resetUploadSuccess());
    docList();
    setLoader(false);
} 
  
   uploadDocData.uploadedSuccess && afterDownload()

const downloadDoc = ( props ) =>{
  let data = props.row.original ? props.row.original : props;
  if(data.pyCategory == 'URL'){
         const cURL = data.BrowserUrl;        
         const fileName = data.FileName;
         fetch(cURL, {
           method: 'GET',
           // headers: {
           //   'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
           //   'Ocp-Apim-Trace': API_TRACE
           // }
         }).then(function(t) {
           return t.blob().then((b)=>{
             var a = document.createElement("a");
             a.href = URL.createObjectURL(b);
             a.setAttribute("download", fileName);
             a.click();
           });
         });
  }else{
          dispatch(fetchAppFileDoc({DocumentID:data.pzInsKey,prgData:applicationData.program, reqstData: data}))
  }
}
const columns = React.useMemo(
  () => [
    {
      Header: 'D-Case ID',
      accessor: '',
  },
      {
          Header: 'D-Case ID',
          accessor: 'DocID',
      },
      {
          Header: 'Uploaded Document',
          accessor: 'DocumentName',
      },
      {
          Header: 'Status',
          accessor: 'DocumentStatus',
      },
      {
          Header: 'Uploaded On',
          accessor: 'DocumentReceptionDate',
      },
      {
          Header: 'Action',
          Cell: props => {
              return <div className="d-flex justify-content-center align-items-center">
                   <Tooltip placement="top" title={'Download'} >
                   <button className="btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white" onClick={()=>{downloadDoc(props)}}> <div className="h-15"> <Download /> </div></button>
          </Tooltip>
                 
              </div>
          },
      },
  ],
  []
);
  return (
    <div>
      {loader && <Loader />}
    <div class="intro-y box mt-lg-5">
    <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
        <h2 class="fw-medium fs-base me-auto">
            Upload Documents 
        </h2>
    </div>
    {applicationData.allowUploadDoc && <div className="intro-y box mt-lg-5 p-5">
    <p className="fw-medium fs-base me-auto">
    Please upload required documents for this application 
        </p>
        <div className="document_header">To ensure your document is uploaded successfully, please ensure the file name is unique and does not contain any special characters.<br></br> Example of correct format: John Doe Income 1.1.25</div>
        <Dropzone maxSize="10485760" onDrop={onDrop}>
      {({ getRootProps, getInputProps, isDragReject }) => (
        <section className="mt-5 px-8">
          <div  {...getRootProps({ className: `dropzone ${files && files.length > 0 ? 'disabled' : ''}}` })}>
            <input {...getInputProps()} />
            <div className="side-menu__icon yellow d-flex justify-content-center">
              <UploadCloud className="h-12 w-6" />
            </div>
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          <p className="pt-1" style={{ fontSize: 10 }}><i>* Maximum File Size is 10MB Per File. Attachments Cannot Exceed 15MB Total. Acceptable File Formats: PDF, JPEG, JPG, PNG, HEIF</i></p>
          {isDragReject && "File type not accepted, sorry!"}
          <aside className={style.dz_files}>
            {files.map((file, index) => (
              <div className={`${style.dz_preview} ${style.dz_preview_border} px-2 py-1`} key={file.name} onClick={(e) => removeImage(e, index,file)}>
                <div className={`${style.dz_image} d-flex justify-content-end color-danger`}><Trash2 /> </div>
                <div className={style.dz_details}>
                  <div className={style.dz_size}><span  ><strong>{Math.round(file.size / 1024)}</strong> KB</span></div>
                  <div className={style.dz_filename}><span  >{file.name}</span></div>
                </div>
              </div>
            ))}
          </aside>
        </section>
      )}
    </Dropzone>
    <div className="text-center">
        <button className="btn btn-yellow" onClick={()=>{ uploadDoc()}}><div className="h-15"> <Upload /></div>Submit Document</button>
    </div>
    </div>}
  </div>
  <Modal
        title=" Upload Completed"
        open={uploadDocData.isUploaded}
        onOk={() => dispatch(resetIsUploaded())}
        onCancel={() => dispatch(resetIsUploaded())}
        cancelButtonProps={{ style: { display: "none" } }}
        width={800}
        maskClosable={true}
        closeIcon={true}
        okText="Ok"
      >
          <p className="fw-medium fs-base text-center mb-3">
          {`Thank you for submitting and the D-Case ID is ${uploadDocData?.docDCaseId.length > 0  && uploadDocData?.docDCaseId.map(e => e.pyID).join(", ")} `}
          </p>
      </Modal>
      <div class="intro-y box mt-lg-5">
    <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
        <h2 class="fw-medium fs-base me-auto">
            Uploaded Documents 
        </h2>
    </div>
      </div>
      {DocumentList.docList.length > 0 ? 
        <Table columns={columns} data={DocumentList.docList} showPageDataCount={5} searchFilter={true}></Table>
      : <div className="intro-y box mt-lg-5 text-center">No documents</div>}
  </div>
  )
}

export default UploadDocuments


